module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("CHAPTER 1")]), _c('br'), _vm._v("The Gluten-Free Vegan Pantry & Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 2")]), _c('br'), _vm._v("Breakfasts")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 3")]), _c('br'), _vm._v("Main Courses")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 4")]), _c('br'), _vm._v("Salads & Soups")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 5")]), _c('br'), _vm._v("Appetizers, Sides & Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 6")]), _c('br'), _vm._v("Desserts & Beverages")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/resource#resource",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegan Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common-3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb590b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 63
// module chunks = 0